import { render, staticRenderFns } from "./SearchTag.vue?vue&type=template&id=77b218fa"
import script from "./SearchTag.vue?vue&type=script&lang=ts"
export * from "./SearchTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports